// extracted by mini-css-extract-plugin
export default {"container":"AutoCompleteInput_container__jJ4nT","inputField":"AutoCompleteInput_inputField__cNrva","suggestion":"AutoCompleteInput_suggestion__OPV-e"};